import { useTranslation } from "react-i18next";
import { DocusignConfig } from "../../../models/DocusignConfig";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ConfirmationModal } from "../../ConfirmationModal";

interface Props {
    info: {
        show: boolean;
        docusignConfig?: DocusignConfig;
    };
    onClose: () => void;
    setMainConfig: (config: DocusignConfig) => void
}

export const SetAgencyMainDocusignConfigModal: React.FC<Props> = ({
    info,
    onClose,
    setMainConfig
}) => {

    const { t } = useTranslation();

    const onSetMainConfig = () => {
        setMainConfig(info.docusignConfig!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("SET_AGENCY_MAIN_DOCUSIGN_CONFIG")}
            isDeleteConfirm={false}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("SET_MAIN_CONFIG"), icon: <CheckIcon />, onClick: onSetMainConfig }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('SET_MAIN_CONFIG_MESSAGE', {label: info.docusignConfig?.label})}
                </label>
            </div>
        </ConfirmationModal>
    )
}